import React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory, Redirect } from "react-router-dom";
import { 
    TasksView, Users, Login, 
    SkillManagementView, FoldersView, FolderManagementView, 
    ChangePassword, ForgotPassword, 
    ResetPassword, Dashboard, TeamManagementView,
    SupervisorIntervention, TagManagement, SupervisorAgentStatusBis } from "components/pages/"
import jwtWorker from 'utils/jwt-worker';
import { ROLES, BASE_ROUTES } from "utils/";
import { AccessDenied, PrivateRoute } from "components/navigation";

export const Routes = () => {

    return (
        <Router history={useHistory} basename={process.env.PUBLIC_URL}>
            <Switch>
                <Route exact path={BASE_ROUTES.LOGIN} component={Login}>
                    {jwtWorker.isUserLogged() && <Redirect to="/home" />}
                </Route>

                <Route exact path={`${BASE_ROUTES.PASSWORD_FIRST_LOGIN}`} component={ChangePassword} >
                    {jwtWorker.isUserLogged() && <Redirect to="/home" />}
                </Route>

                <Route exact path={`${BASE_ROUTES.RESET_PASSWORD}/:uuid`} component={ResetPassword} />
                <Route exact path={BASE_ROUTES.FORGOT_PASSWORD} component={ForgotPassword} />
                <Route exact path={`${BASE_ROUTES.CHANGE_PASSWORD}`} component={ChangePassword} />
                {/* FOLDER ROUTES */}
                <PrivateRoute exact path={BASE_ROUTES.FOLDERS_ROUTE} role={ROLES.AGENT} component={FoldersView} />
                <PrivateRoute exact path={`${BASE_ROUTES.FOLDERS_ROUTE}/:item`} role={ROLES.AGENT} component={FoldersView} />
                {/* ADMIN ROUTES */}
                <PrivateRoute exact path={`${BASE_ROUTES.ADMIN_ROUTE}/users`} role={ROLES.ADMIN} component={Users} />
                <PrivateRoute exact path={`${BASE_ROUTES.ADMIN_ROUTE}/teams`} role={ROLES.ADMIN} component={TeamManagementView} />
                <PrivateRoute exact path={`${BASE_ROUTES.ADMIN_ROUTE}/folder-management`} role={ROLES.ADMIN} component={FolderManagementView} />
                <PrivateRoute exact path={`${BASE_ROUTES.ADMIN_ROUTE}/skills`} role={ROLES.ADMIN} component={SkillManagementView} />
                <PrivateRoute exact path={`${BASE_ROUTES.ADMIN_ROUTE}/tag-management`} role={ROLES.ADMIN} component={TagManagement} />
                {/* ANALYTIC ROUTES */}
                <PrivateRoute exact path={`${BASE_ROUTES.ANALYTICS_ROUTE}`} role={ROLES.ANALYST} component={Dashboard} />
                <PrivateRoute exact path={`${BASE_ROUTES.ANALYTICS_ROUTE}/:item`} role={ROLES.ANALYST} component={Dashboard} />
                {/* SUPERVISION ROUTES */}
                <PrivateRoute exact path={`${BASE_ROUTES.SUPERVISION_ROUTE}/agents-status`} role={ROLES.SUPERVISOR} component={SupervisorAgentStatusBis} />
                <PrivateRoute exact path={`${BASE_ROUTES.SUPERVISION_ROUTE}/intervention`} role={ROLES.SUPERVISOR} component={SupervisorIntervention} />
                {/* OTHERS  */}
                <PrivateRoute exact path={`${BASE_ROUTES.TASKS_ROUTE}`} role={ROLES.AGENT} component={TasksView} />
                <PrivateRoute exact path={BASE_ROUTES.ACCESS_DENIED} AccessDenied component={AccessDenied} />
                <Route path="*">
                    <Redirect to={jwtWorker.getDefaultRoute()} />
                </Route>
            </Switch>
        </Router>
    );
}



